/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { VWQIcon } from "@sunwing/icons";
import { RCL } from "../../components/RCL";
import config from "../../app/config";

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("./FaqSearchResultVwq.module.scss");
  } else {
    styles = await import("./FaqSearchResult.module.scss");
  }
})();

function getPagination(currentPage, totalPages) {
  let MAX_PAGES = 6;
  let pages = [];

  if (totalPages <= MAX_PAGES) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    const halfMax = Math.floor(MAX_PAGES / 2);

    if (currentPage <= halfMax) {
      for (let i = 1; i <= MAX_PAGES - 2; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    } else if (currentPage >= totalPages - halfMax + 1) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - MAX_PAGES + 3; i <= totalPages; i++) {
          pages.push(i);
        }
    } else {
      pages.push(1);
      pages.push('...');
      for (let i = currentPage - halfMax + 2 ; i <= currentPage + halfMax -1; i++) {
        pages.push(i);
      }
      pages.push('...');
      pages.push(totalPages);
    }
  }

  return pages;
}

  const Pagination = ({
    infosPerPage,
    totalInfos,
    setCurrentPage,
    currentPage
  }) => {
    const[pageNumbers, setPageNumbers] = useState([]);
    
    const [leftMoveDisabled, setLeftMoveDisabled] = useState(false);
    const [rightMoveDisabled, setRightMoveDisabled] = useState(true);

    useEffect(() => {
      const totalpages = Math.ceil(totalInfos / infosPerPage);
      setPageNumbers(getPagination(currentPage, totalpages));
      
      getMoveDisabled();

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, totalInfos]);

    const getMoveDisabled = () => {

      if(currentPage === 1)
        setLeftMoveDisabled(true)
      else
        setLeftMoveDisabled(false);

      if(currentPage === Math.ceil(totalInfos / infosPerPage))
        setRightMoveDisabled(true)
      else 
        setRightMoveDisabled(false);

    }

    const paginate = (pageNumber, e) => {
      e.preventDefault();
      switch (pageNumber){
        case "First" :
          setCurrentPage(1);
          break;
        case "Back" :
          if(currentPage > 1)
            setCurrentPage(currentPage - 1);
          break;
        case "Next" :
          if(currentPage < Math.ceil(totalInfos / infosPerPage))
            setCurrentPage(currentPage + 1);
          break;
        case "Last" :
          setCurrentPage(Math.ceil(totalInfos / infosPerPage));
          break;
        case "..." :
          break;
        default:
          setCurrentPage(pageNumber);
          break;
      }
      getMoveDisabled();
    };

    return (
      <nav>
        <ul className={styles.pagination}>
          <li key={'First'} className={styles.paginationIconContainer}>
            <button disabled ={leftMoveDisabled} onClick={(e) => paginate('First', e)} >
              <VWQIcon name="end-end-micro" className={leftMoveDisabled ? styles.paginationIconDisabled : styles.paginationIcon} disabled ={leftMoveDisabled}/> 
              <span className={styles.paginationText}><RCL searchKey="first-class" /></span> 
            </button>
          </li>
          <li key={'Back'} className={styles.paginationIconContainer}>
            <button disabled ={leftMoveDisabled} onClick={(e) => paginate('Back', e)} >
              <VWQIcon name="chevron-left-micro" className={leftMoveDisabled ? styles.paginationIconDisabled : styles.paginationIcon} disabled ={leftMoveDisabled}/> 
              <span className={styles.paginationText}><RCL searchKey="back" /></span>
            </button>
          </li>
          {pageNumbers.map((number) => (
            <li key={number} className={`${currentPage === number ? styles.active : ""}`}>
              <button onClick={(e) => paginate(number, e)} className={styles.paginationButton}>
                <span className={styles.paginationNumber}>{number}</span>
              </button>
            </li>
          ))}
          <li key={'Next'} className={styles.paginationIconContainer}>
            <button disabled={rightMoveDisabled} onClick={(e) => paginate('Next', e)} >
            <span className={styles.paginationText}><RCL searchKey="next" /></span>
            <VWQIcon name="chevron-right-micro" className={rightMoveDisabled ? styles.paginationIconDisabled : styles.paginationIcon} disabled ={rightMoveDisabled}/>
            </button>
          </li>
          <li key={'Last'} className={styles.paginationIconContainer}>
            <button disabled={rightMoveDisabled} onClick={(e) => paginate('Last', e)} >
            <span className={styles.paginationText}><RCL searchKey="WVI-pagination-last" /></span>
            <VWQIcon name="end-start-micro" className={rightMoveDisabled ? styles.paginationIconDisabled : styles.paginationIcon} disabled ={rightMoveDisabled}/>
            </button>
          </li>
        </ul>
      </nav>
    );
  };

export default Pagination;